








































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {EditPatientVascularAccess} from "@/api/vascularAccess"

@Component({
	components: {}
})
export default class XX extends AbpBase {
	@Prop() value: boolean
	@Prop() data: any

	form: any = {}

	created() {
		this.form = Object.assign({}, this.data.item)
		this.form.outComeDate = new Date()
		this.dateChange(this.form.outComeDate)
		this.form.isOutCome = true
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	dateChange(date: any) {
		if (typeof date === 'string') {
			date = new Date(date)
		}
		let dateSpan = date.getTime() - (new Date(this.form.inputDate)).getTime()
		dateSpan = Math.abs(dateSpan)
		let days = Math.floor(dateSpan / (24 * 3600 * 1000))
		this.form.lifetime = days
	}

	async save() {
		let res = await EditPatientVascularAccess(this.form)
		if (res.status === 1) {
			this.$emit('saveSuccess')
		}
	}

	cancel() {
		(this.$refs.roleForm as any).resetFields();
		this.$emit('input', false)
	}

	get modalTitle() {
		return this.data.item.vaType + '通路转归'
	}

	roleRule = {

		lifetime: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('DisplayName')), trigger: 'blur'}],
		outComeReason: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('DisplayName')),}],
		outComeReasonOther: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('DisplayName')),}],
		outComeDate: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('DisplayName')),}],
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/road/outCome.vue